import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
	new Swiper('.image-slider-swiper', {
		slidesPerView: 7,
		spaceBetween: 20,
		modules: [Navigation, Pagination],
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			1024: {
				slidesPerView: 7,
				spaceBetween: 20
			},
			768: {
				slidesPerView: 5,
				spaceBetween: 20
			},
			0: {
				slidesPerView: 3.2,
				spaceBetween: 20
			}
		}
	});
});


